import Actions from "./Actions";
import Name from "./Name";
import OtpTextCopy from "./OtpTextCopy";

const otpComponents = {
  Actions,
  Name,
  OtpTextCopy
}

export default otpComponents